<div class="explore">

  <!--begin::Partners List(Carousel)-->
  <sng-partners-list-carousel>
  </sng-partners-list-carousel>
  <!--end::Partners List(Carousel)-->

  <!--begin::Posts/Events List(Carousel)-->
  <sng-posts_events-list-carousel *ngIf="configAccess[0]" [type]="'all'" access="'null">
  </sng-posts_events-list-carousel>
  <!--end::Posts/Events List(Carousel)-->

</div>